
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1608443293530",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "8434",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M870.144 154.2656H152.832a49.664 49.664 0 0 0-49.6128 49.664v481.9968c0 27.4432 22.2208 49.664 49.664 49.664h327.1168V808.96h-221.696a31.488 31.488 0 1 0 0 62.976h245.0432a31.488 31.488 0 0 0 16.2816 0h245.0432a31.488 31.488 0 1 0 0-62.976h-221.696v-73.3184h327.168c27.392 0 49.664-22.2208 49.664-49.664V203.9296a49.664 49.664 0 0 0-49.664-49.664z m-13.312 518.3488H166.144V217.2416h690.688v455.3728z",
        "p-id": "8435"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M309.4016 553.8304a31.3856 31.3856 0 0 0 20.992-8.0896l105.728-95.0272a3.8912 3.8912 0 0 1 5.12-0.1024l93.3888 76.6976c26.2656 21.504 64.512 19.968 88.9344-3.584l111.9232-108.032a31.488 31.488 0 0 0-43.776-45.312l-111.872 108.032a3.8912 3.8912 0 0 1-5.2224 0.2048L481.28 401.92a66.9184 66.9184 0 0 0-87.1936 1.9456L288.256 498.8928a31.488 31.488 0 0 0 21.0944 54.9376z",
        "p-id": "8436"
      }
    }
  ]
})
    }
  